import React from 'react';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import { withStyles } from '@material-ui/core/styles';

const formatDate = (date) => {
    if (!date) return '';
    return moment(date).format('DD/MM/YYYY');
  };

const styles = theme => ({
  policyContainer: {
    border: '1px solid #2D6DF6',
    borderRadius: '16px',
    margin: isMobile ? '20px -8px 0' : '20px 0 0',
    backgroundColor: '#FFFFFF'
  },
  policyRowTop: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 1fr',
    height: isMobile ? 'auto' : '56px',
    alignItems: 'end',
    borderBottom: '1px solid rgba(1,25,160,0.25)'
  },
  policyRowBottom: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    height: 'auto',
    minHeight: '56px'
  },
  policyColumn: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    padding: isMobile ? '6px 4px 4px 4px' : '6px 0 4px 10px'
  },
  policyBorderColumn: {
    display: 'flex',
    flexDirection: 'column',
    borderLeft: '1px solid rgba(1,25,160,0.25)',
    borderRight: '1px solid rgba(1,25,160,0.25)',
    height: '100%',
    justifyContent: 'center',
    padding: isMobile ? '6px 4px 4px 4px' : '6px 0 4px 10px'
  },
  policyColumnLast: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    paddingLeft: isMobile ? '4px' : '10px'
  },
  policyLabel: {
    color: '#000000',
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'Sura Sans',
    lineHeight: '16px'
  },
  policyValue: {
    color: '#2D6DF6',
    fontSize: isMobile ? '14px' : '16px',
    fontWeight: '400',
    fontFamily: 'Sura Sans'
  }
});

const PolicyDetails = ({ policy, classes }) => {
  return (
    <div className={classes.policyContainer}>
      <div className={classes.policyRowTop}>
        <div className={classes.policyColumn}>
          <span className={classes.policyLabel}>
            Nombre contratante:
          </span>
          <span className={classes.policyValue}>
            {policy.policy_details.customer_name}
          </span>
        </div>
        <div className={classes.policyBorderColumn}>
          <span className={classes.policyLabel}>
            Inicio de vigencia:
          </span>
          <span className={classes.policyValue}>
            {formatDate(policy.policy_details.started_at)}
          </span>
        </div>
        <div className={classes.policyColumn}>
          <span className={classes.policyLabel}>
            Fin de vigencia:
          </span>
          <span className={classes.policyValue}>
            {formatDate(policy.policy_details.ended_at)}
          </span>
        </div>
      </div>
      <div className={classes.policyRowBottom}>
        <div className={classes.policyColumn}>
          <span className={classes.policyLabel}>
            Oficina:
          </span>
          <span className={classes.policyValue}>
            {policy.policy_details.office_id}
          </span>
        </div>
        <div className={classes.policyBorderColumn}>
          <span className={classes.policyLabel}>
            Ramo:
          </span>
          <span className={classes.policyValue}>
            {policy.policy_details.product_id}
          </span>
        </div>
        <div className={classes.policyColumn}>
          <span className={classes.policyLabel}>
            Grupo:
          </span>
          <span className={classes.policyValue}>
            {policy.policy_details.group_id}
          </span>
        </div>
        <div className={classes.policyBorderColumn}>
          <span className={classes.policyLabel}>
            Subgrupo:
          </span>
          <span className={classes.policyValue}>
            {policy.policy_details.subgroup_id}
          </span>
        </div>
        <div className={classes.policyColumnLast}>
          <span className={classes.policyLabel}>
            Moneda:
          </span>
          <span className={classes.policyValue}>
            {policy.policy_details.currency}
          </span>
        </div>
      </div>
    </div>
  );
};
export default withStyles(styles)(PolicyDetails);



// WEBPACK FOOTER //
// ./src/containers/client/receipts/PolicyDetails.js